/**
 * 组合label样式
 * 填充 + 边框(带标题)
 */
import * as React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { qAccessibilityLabel } from '@qnpm/q-design-utils';
import { swapBorderStyle, completeMirrorBorderStyle } from '../handlers';
export default class CombineLabel extends React.PureComponent {
    constructor(props) {
        super(props);
        this.reLayoutFinished = false;
        this.state = {
            containerWidth: -1,
            leftSectionWidth: -1
        };
    }
    render() {
        const { textLeftStyle, textArray, text, title, leftIcon, accessibilityPreName, isReverse, maxLabelWidth } = this.props;
        if (!text && !Array.isArray(textArray)) {
            return <View />;
        }
        const wrapperStyle = {
            wrappeRightStyle: this.props.wrappeRightStyle || {},
            wrapperLeftStyle: this.props.wrapperLeftStyle || {}
        };
        let { wrapperLeftStyle } = isReverse
            ? swapBorderStyle(wrapperStyle)
            : wrapperStyle;
        let rightContent = this.getRightContent();
        const reverseStyle = isReverse ? { flexDirection: 'row-reverse' } : {};
        const textReverseStyle = isReverse
            ? { marginLeft: 2 }
            : { marginRight: 2 };
        wrapperLeftStyle = rightContent
            ? wrapperLeftStyle
            : completeMirrorBorderStyle(wrapperLeftStyle);
        const widthStyle = maxLabelWidth && this.reLayoutFinished
            ? { maxWidth: maxLabelWidth }
            : {};
        return (<View key={`label-combine`} style={[
            { flexDirection: isReverse ? 'row-reverse' : 'row' },
            widthStyle
        ]} {...qAccessibilityLabel(`${accessibilityPreName}qdLabel`)} onLayout={(e) => {
            const { layout } = e.nativeEvent;
            const { width } = layout || {};
            this.setState({
                containerWidth: width
            });
        }}>
                <View style={[wrapperLeftStyle, reverseStyle]} {...qAccessibilityLabel(`${accessibilityPreName}qdLabel#left`)} onLayout={(e) => {
            const { layout } = e.nativeEvent;
            const { width } = layout || {};
            this.setState({
                leftSectionWidth: width
            });
        }}>
                    {React.isValidElement(leftIcon) ? (<View style={textReverseStyle}>{leftIcon}</View>) : null}
                    <Text numberOfLines={1} style={textLeftStyle}>
                        {title}
                    </Text>
                </View>
                {rightContent}
            </View>);
    }
    getRightContent() {
        const { textRightStyle, textArray, text, splitStyle, accessibilityPreName, isReverse } = this.props;
        const wrapperStyle = {
            wrappeRightStyle: this.props.wrappeRightStyle || {},
            wrapperLeftStyle: this.props.wrapperLeftStyle || {}
        };
        let { wrappeRightStyle } = isReverse
            ? swapBorderStyle(wrapperStyle)
            : wrapperStyle;
        if (Array.isArray(textArray) && textArray.length > 0) {
            const itemWidths = this.getEveryItemWidth();
            return (<View style={[wrappeRightStyle]}>
                    {textArray.map((item, index) => {
                let itemWidth = itemWidths && itemWidths.length > 0
                    ? itemWidths[index]
                    : {};
                if (index === 0) {
                    return (<Text key={`${text}${index}`} {...qAccessibilityLabel(`${accessibilityPreName}qdLabel#right#${index}`)} numberOfLines={1} ellipsizeMode={'tail'} style={[textRightStyle, itemWidth]}>
                                    {item}
                                </Text>);
                }
                else {
                    return [
                        <View key={`${text}${index}`} style={splitStyle}/>,
                        <Text key={`${text}${index}`} {...qAccessibilityLabel(`${accessibilityPreName}qdLabel#right#${index}`)} ellipsizeMode={'tail'} numberOfLines={1} style={[textRightStyle, itemWidth]}>
                                    {item}
                                </Text>
                    ];
                }
            })}
                </View>);
        }
        else if (text && typeof text === 'string') {
            return (<View style={wrappeRightStyle} {...qAccessibilityLabel(`${accessibilityPreName}qdLabel#right`)}>
                    {React.isValidElement(text) ? text : null}
                    {typeof text === 'string' ? (<Text numberOfLines={1} style={textRightStyle}>
                            {text}
                        </Text>) : null}
                </View>);
        }
        return null;
    }
    /**
     * 根据每个item文字的长度计算右部分每个item的宽度，
     */
    getEveryItemWidth() {
        const { textArray, maxLabelWidth, labelPadding, spliteMargin } = this.props;
        if (Array.isArray(textArray) && textArray.length > 0) {
            let array = textArray.map((value) => {
                return {};
            });
            const { containerWidth, leftSectionWidth } = this.state;
            if (maxLabelWidth &&
                typeof maxLabelWidth === 'number' &&
                labelPadding &&
                typeof labelPadding === 'number' &&
                spliteMargin &&
                typeof spliteMargin === 'number' &&
                containerWidth > 0 &&
                leftSectionWidth > 0 &&
                Math.ceil(containerWidth) >= Math.ceil(maxLabelWidth)) {
                this.reLayoutFinished = true;
                // 右部分，除去左右padding+每个竖向分割线的padding
                const remainWidth = maxLabelWidth -
                    leftSectionWidth -
                    (labelPadding + StyleSheet.hairlineWidth) *
                        (textArray.length > 1 ? textArray.length - 1 : 0) -
                    spliteMargin * 2;
                let totalTextLength = 0;
                textArray.forEach((str) => {
                    totalTextLength += str.length;
                });
                array = textArray.map((value) => {
                    let everWidth = (value.length / totalTextLength) * remainWidth;
                    return { width: everWidth };
                });
                return array;
            }
            else {
                return array;
            }
        }
        return [];
    }
}
